import * as AlertDialog from '@givebutter/primitives/alert-dialog';
import { Label } from '@givebutter/primitives/label';
import * as Input from 'components/input';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';

interface ContactLogEmailDialogProps extends AlertDialog.AlertDialogRootProps {}
const ContactLogEmail = (props: ContactLogEmailDialogProps) => {
    const { children, ...rest } = props;
    const { emailConfig } = useCurrentAccount();

    const handleInputCopyClick = (e: React.MouseEvent<HTMLInputElement>) => {
        if (e.target instanceof HTMLInputElement) {
            e.target.select();
        }
    };

    return (
        <AlertDialog.Root type="info" {...rest}>
            {children}
            <AlertDialog.Portal>
                <AlertDialog.Overlay />
                <AlertDialog.Content className="max-w-lg p-6">
                    <div className="flex flex-col gap-4">
                        <AlertDialog.Header>
                            <AlertDialog.Icon />
                            <AlertDialog.Close />
                        </AlertDialog.Header>
                        <AlertDialog.Title>BCC & Forward Email Logging</AlertDialog.Title>
                        <div className="flex flex-col gap-4">
                            <div>
                                <p className="block text-sm">
                                    Emails logged to Givebutter using the BCC or forwarding address
                                    are automatically associated with the recipient's contact
                                    records. If a contact does not exist for a given recipient, it
                                    will be created automatically. The email content and any
                                    included attachments are logged as a contact activity in their
                                    timeline.{' '}
                                    <a
                                        href="https://help.givebutter.com/en/articles/5497863-log-emails-with-bcc-or-forwarding-address"
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        Learn more about how email logging works.
                                    </a>
                                </p>
                            </div>
                            <div>
                                <Label htmlFor="bcc_address" className="text-sm">
                                    BCC Address
                                </Label>
                                <Input.Root>
                                    <Input.Form
                                        placeholder="BCC Address"
                                        name="bcc_address"
                                        value={emailConfig.bccAddress ?? ''}
                                        id="bcc_address"
                                        readOnly={true}
                                        onClick={handleInputCopyClick}
                                    />
                                </Input.Root>
                                <div className="h-1" />
                                <Label htmlFor="forward_address" className="text-sm">
                                    Forwarding Address
                                </Label>
                                <Input.Root>
                                    <Input.Form
                                        placeholder="Forwarding Address"
                                        name="forward_address"
                                        value={emailConfig.forwardAddress ?? ''}
                                        id="forward_address"
                                        readOnly={true}
                                        onClick={handleInputCopyClick}
                                    />
                                </Input.Root>
                            </div>
                        </div>
                    </div>
                </AlertDialog.Content>
            </AlertDialog.Portal>
        </AlertDialog.Root>
    );
};

const ContactLogEmailTrigger = AlertDialog.Trigger;

const Root = ContactLogEmail;
const Trigger = ContactLogEmailTrigger;

export { ContactLogEmail, ContactLogEmailTrigger, Root, Trigger };
